const enGB = {
  navigation: {
    mydevice: "Mein Gerät",
    mymobile: "My mobile"
  },
  photoorganiser: {
    navigation: {
      photos: "Fotos",
      favorites: "Favoriten",
      collections: "Sammlungen",
      events: "Veranstaltungen",
      latestuploads: "Neueste Uploads"
    },
    empty(source) {
      return "Du hast keine Fotos in " + source
    }
  },
  mymobile: {
    title: "Get your phone photos in an instant!",
    qrcode: {
      title: "Scan the QR code",
      subtitle: "(No need to install App)"
    },
    instruction: {
      title: "Let's get started!",
      step_1: "Open your camera app",
      step_2: "Scan the QR code",
      step_3: "Follow the instruction on your mobile"
    }
  },
  layout: {
    flex: "Flexibel",
    square: "Quadratisch"
  },
  calender: {
    allmonths: "Alle Monate",
    allyears: "Alle Jahre",
    months: {
      january: "Januar",
      february: "Februar",
      march: "März",
      april: "April",
      may: "Mai",
      june: "Juni",
      july: "Juli",
      august: "August",
      september: "September",
      october: "Oktober",
      november: "November",
      december: "Dezember"
    }
  },
  generic: {
    sortBy: "Sortieren nach",
    selected: "Ausgewählt",
    done: "Fotos hinzufügen",
    back: "Zurück",
    images: "Fotos",
    selection: "Auswahl",
    date: "Datum",
    name: "Name",
    az: "Dateiname A-Z",
    za: "Dateiname Z-A",
    newestfirst: "Aufnahmedatum neu-alt",
    oldestfirst: "Aufnahmedatum alt-neu",
    photos: "Fotos",
    all: "Alle",
    yes: "Ja",
    no: "Nein",
    nodate: "Kein Datum"
  },
  rangeText: {
    minMax(min, max) {
      return "Du musst zwischen " + min + " und " + max + " Fotos auswählen"
    },
    min(min) {
      return "Du benötigst mindestens " + min + " Fotos, um dein Fotobuch zu gestalten."
    },
    max(max) {
      return "Du kannst maximal " + max + "  Fotos auswählen"
    }
  },
  addMorePhotos: "Weitere Fotos hinzufügen",
  upload: {
    browseButton: "Fotos hinzufügen",
    uploadlimit(maxSize) {
      return "Bilder müssen eine Dateigröße kleiner als " + maxSize + " besitzen"
    },
    dragImage: "Oder ziehe Ihre Dateien per Drag & Drop hierher.",
    errors: {
      GENERIC_ERROR: "Etwas ist schief gegangen. Versuch es bitte später erneut oder kontaktiere unseren Kundenservice.",
      EMPTY_FILE: "Bildreferenz verloren, bitte füge das Bild erneut hinzu",
      MAX_FILE_SIZE: "Datei muss kleiner als {0} MB sein",
      UNSUPPORTED_FILE_TYPE: "Dateiformat nicht unterstützt",
      MAX_IMAGE_RESOLUTION: "Datei muss kleiner als {0} pixels sein",
      INVALID_IMAGE: "Datei ist beschädigt"
    },
    errorSummary(number) {
      return number + " Dateien konnten nicht hochgeladen werden"
    },
    errorDialog: {
      headline: "Hoppla!",
      ingress: "Die folgenden Dateien konnten nicht hochgeladen werden:",
      filenameColumn: "Datei",
      reasonColumn: "Grund"
    },
    uploaded: "Hochgeladen",
    estimating: "Zeit wird geschätzt",
    estimatedleft: "Geschätzte verbleibende Zeit",
    ok: "OK",
    cancel: "Abbrechen",
    details: "Details"
  }
}

export default enGB
